import React, { useState, useContext } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useHistory } from 'react-router-dom';
import './DownloadInvoice.css';
import { ROUTES, INVOICE_LAYOUTS, STORAGE_KEYS, BACKEND_URL } from 'const';
import PrintIcon from '@mui/icons-material/Print';
import { useTranslation } from "react-i18next";
import { ShopContext } from 'Context/ShopContext';

const DownloadInvoice = ({ bill, showOptions = true }) => {
  const { t } = useTranslation("common");
  const { shop } = useContext(ShopContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadInvoice = (type) => {
    let formatType = type;
    if (!formatType) {
      if (shop?.web_invoice_format === INVOICE_LAYOUTS.A4_BACKEND) formatType = INVOICE_LAYOUTS.A4_BACKEND;
      else if (shop?.web_invoice_format === INVOICE_LAYOUTS.A5_BACKEND) formatType = INVOICE_LAYOUTS.A5_BACKEND;
      else if (shop?.web_invoice_format === INVOICE_LAYOUTS.THREE_INCH) formatType = INVOICE_LAYOUTS.THREE_INCH;
    }
    billToPdf(bill, formatType);
    handleMenuClose();
  };

  const billToPdf = async (bill, type) => {
    const authToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);

    if (!authToken || !shopId) {
      console.error('Missing auth token or shop ID');
      return;
    }

    if (!bill || !bill.bill_no) {
      console.error('Invalid bill object:', bill);
      return;
    }

    const url = `${BACKEND_URL}/reports/sales/details/pdf/?token=${authToken}&shop_id=${shopId}&bill_no=${bill.bill_no}&invoice_format=${type}`;

    window.open(url);
  };

  const handleEditRedirect = () => {
    const billId = bill?.id;

    if (!billId) {
      console.error('Bill ID is missing or invalid:', bill);
      return;
    }

    history.push(`${ROUTES.MANAGE_SALES}?id=${billId}`);
    handleMenuClose();
  };

  return (
    <div className="menu-container">
      <Tooltip title={t("Print Invoice")}>
        <PrintIcon className="iconBtn" onClick={() => handleDownloadInvoice()} />
      </Tooltip>

      {showOptions && (
        <div className="more-options-container">
          <Tooltip title={t("More options")}>
            <IconButton aria-label={t("More options")} onClick={handleMenuClick}>
              <MoreVertIcon className="iconBtn" />
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            MenuListProps={{ className: "menu-list" }}
          >
            <MenuItem onClick={() => handleDownloadInvoice(INVOICE_LAYOUTS.A4_BACKEND)} className="menu-item">
              {t("Invoice A4")}
            </MenuItem>
            <MenuItem onClick={() => handleDownloadInvoice(INVOICE_LAYOUTS.A4_BACKEND)} className="menu-item">
              {t("PDF A4")}
            </MenuItem>
            <MenuItem onClick={() => handleDownloadInvoice(INVOICE_LAYOUTS.A5_BACKEND)} className="menu-item">
              {t("Invoice A5")}
            </MenuItem>
             <MenuItem onClick={() => handleDownloadInvoice(INVOICE_LAYOUTS.A5_BACKEND)} className="menu-item">
              {t("PDF A5")}
            </MenuItem>
            <MenuItem onClick={() => handleDownloadInvoice(INVOICE_LAYOUTS.THREE_INCH)} className="menu-item">
              {t("Invoice 3 Inch")}
            </MenuItem>
            <MenuItem onClick={handleEditRedirect} className="menu-item">
              {t("Edit")}
            </MenuItem>
          </Menu>
        </div>
      )}
    </div>
  );
};

export default DownloadInvoice;
